/**
 * @file openapi跳转相关
 * @author quda
 */
import common from '@/common/utils/com.js';
import {getParamsFromUrl} from '@baidu/map-fe-utils';


/**
 * 触发iOS返回webview事件
 */
function registerIOSBack() {
    if (common.plat.isIos) {
        common.requestBdApi('bdapi://robackRefresh');
    }
}

/**
 * 透明壳回端
 *
 */
export const backToNativeWithTransparent = () => {
    let openapi
        = 'baidumap://map/cost_share?transparentWeb=0&navigationStatus=2&popRooot=no&hiddenBackBtn=0&hiddenTitle=1&url='
            + encodeURIComponent(location.origin + location.pathname + '?activity_id='
            + getParamsFromUrl().activity_id);
    const options = {
        launchInNA: true, // 是否调起地图, 默认调起
        openapi: openapi, // 默认用cost_share调起当前页面
        // isDuer: false, // 度口令打开
        immediately: false // 若调起客户端失败，是否立即执行失败回调。默认2s后执行失败回调
    };
    common.openMapClient(options);
};

/**
 * 透明壳带hash回端
 *
 */
export const backToNativeWithHash = (index = '', ik = '') => {
    let openapi
        = 'baidumap://map/cost_share?transparentWeb=0&navigationStatus=2&popRooot=no&hiddenBackBtn=0&hiddenTitle=1&url='
            + encodeURIComponent(location.origin + location.pathname + `?index=${index}&ik=${ik}` + location.hash);
    const options = {
        launchInNA: true, // 是否调起地图, 默认调起
        openapi: openapi, // 默认用cost_share调起当前页面
        // isDuer: false, // 度口令打开
        immediately: false // 若调起客户端失败，是否立即执行失败回调。默认2s后执行失败回调
    };
    common.openMapClient(options);
};

/**
 * 透明壳打开页面
 * @param {string} url - 跳转url
 */
export const jumpByOpenapi = (url, needBackToNative = true, isNoBar = true) => {
    let base = '';
    if (!url) {
        return;
    }
    if (common.plat.isNative) {
        if (url.indexOf('baidumap') !== -1) {
            registerIOSBack();
            location.href = url;
            return;
        }
        if (isNoBar) {
            base = 'baidumap://map/cost_share?popRoot=no&transparentWeb=0&navigationStatus=2&hiddenBackBtn=0&hiddenTitle=1&url=';
        }
        else {
            base = 'baidumap://map/cost_share?hideshare=1&popRoot=no&mode=NORMAL_MODE&url=';
        }
        registerIOSBack();
        location.href = base + encodeURIComponent(url);
    }
    else {
        if (needBackToNative) {
            backToNativeWithTransparent();
        }
        else {
            location.href = url;
        }
    }
};

/**
 * 透明壳打开页面
 * @param {string} url - 跳转url
 */
export const jumpByOpenapiWithHash = (url, needBackToNative = true, isNoBar = true) => {
    let base = '';
    if (!url) {
        return;
    }
    if (common.plat.isNative) {
        if (url.indexOf('baidumap') !== -1) {
            registerIOSBack();
            location.href = url;
            return;
        }
        if (isNoBar) {
            base = 'baidumap://map/cost_share?popRoot=no&navigationStatus=2&hiddenTitle=1&url=';
        }
        else {
            base = 'baidumap://map/cost_share?hideshare=1&popRoot=no&mode=NORMAL_MODE&url=';
        }
        registerIOSBack();
        location.href = base + encodeURIComponent(url);
    }
    else {
        if (needBackToNative) {
            backToNativeWithHash();
        }
        else {
            location.href = url;
        }
    }
};


export const jumpToPano = pid => {
    const param = {
        pid: pid,
        from_source: 'winter-olympic'
    };

    const jsonParam = JSON.stringify(param);
    const base = 'baidumap://map/component?comName=streetscape&popRoot=no&target=street_scape_page&param=';
    const url = base + encodeURIComponent(jsonParam);
    registerIOSBack();
    window.location.href = url;
};

export const jumpFinePano = uid => {
    if (common.plat.isNative) {
        const url = `https://scenes.map.baidu.com/static/h5-project/fine-pano/fine-pano.html?uid=${uid}&fr=yuntour2&isTransparent=1`;
        const base = 'baidumap://map/cost_share?popRoot=no&transparentWeb=0&navigationStatus=2&hiddenBackBtn=1&hiddenTitle=1&url=';
        window.location.href = base + encodeURIComponent(url);
    }
    else {
        backToNativeWithTransparent();
    }
};

export const jumpQualityPano = uid => {
    if (common.plat.isNative) {
        const url = `https://scenes.map.baidu.com/static/h5-project/quality-pano/quality-pano.html?uid=${uid}&fr=yuntour2&isTransparent=1`;
        const base = 'baidumap://map/cost_share?popRoot=no&transparentWeb=0&navigationStatus=2&hiddenBackBtn=1&hiddenTitle=1&url=';
        window.location.href = base + encodeURIComponent(url);
    }
    else {
        backToNativeWithTransparent();
    }
};


export const jumpPoi = (uid, isHalf = true) => {
    if (!uid) {
        return;
    }
    const type = isHalf ? 'detail_bar' : 'detail_page';
    const url = 'baidumap://map/place/detail?popRoot=no&show_type=' + type + '&uid=' + uid;
    if (common.plat.isNative) {
        location.href = url;
    }
    else {
        backToNativeWithTransparent();
    }
};
